import script from "./BidList.vue?vue&type=script&setup=true&lang=js"
export * from "./BidList.vue?vue&type=script&setup=true&lang=js"

import "./BidList.vue?vue&type=style&index=0&id=22de0646&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22de0646"]])

export default __exports__